import { render, staticRenderFns } from "./newPlayer.vue?vue&type=template&id=0c32ed78&scoped=true"
import script from "./newPlayer.vue?vue&type=script&lang=js"
export * from "./newPlayer.vue?vue&type=script&lang=js"
import style0 from "./newPlayer.vue?vue&type=style&index=0&id=0c32ed78&prod&scoped=true&lang=css"
import style1 from "./newPlayer.vue?vue&type=style&index=1&id=0c32ed78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c32ed78",
  null
  
)

export default component.exports